import React from 'react'
import { CompanyItems } from '../../../domain/company'
import ArrowNext from '../../../../assets/arrowNext.png'
import { Badge } from '../../../../components/atoms/Badge/Badge'
import { useNavigate } from 'react-router-dom'

interface ListCompanyItemProps {
    company: CompanyItems
    onClick: (company: CompanyItems) => void
}

const ListCompanyItem: React.FC<ListCompanyItemProps> = ({
    company,
    onClick,
}) => {
    const navigate = useNavigate()

    const handleClick = () => {
        navigate(`/companies/${company.id}`)
        onClick?.(company)
    }

    const formatDate = (dateString: string) => {
        const date = new Date(dateString)
        const day = String(date.getDate()).padStart(2, '0')
        const month = date.toLocaleDateString('en-US', { month: 'short' })
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        return `${day} ${month} ${year} ${hours}:${minutes}`
    }
    return (
        <div
            onClick={handleClick}
            className="flex justify-between items-center py-4 px-6 border border-[#CBD5E1] hover:border-[#1F2531] cursor-pointer transition-colors duration-200 rounded-xl w-full h-[76px]"
        >
            <div className={'text-left'}>
                <h3 className="text-lg font-bold">{company.name}</h3>
                <div className={'flex items-center gap-2'}>
                    <p className="text-gray-600">
                        {formatDate(company.created_at)}
                    </p>
                    |
                    <Badge
                        text={company.warehouse_count + '  Warehouses'}
                        className="h-[18px] bg-neutral-400 rounded-full"
                        classNameText="text-xs px-2 text-white"
                        color="#94A3B8"
                    />
                </div>
            </div>
            <img className="mr-3" src={ArrowNext} alt="ArrowNext" />
        </div>
    )
}

export default ListCompanyItem
